import { apiClient } from "@/shared/services/api";
import type { ApiResponse } from "@/features/auth/services/authApi";

export interface GreenhouseStockReserveReleaseDto {
  id: string;
  greenhouseStockEntryId: string;
  cropTypeId: string;
  cropTypeName: string;
  variety?: string;
  trayType?: string;
  stockUnit: string;
  quantityRequested: number;
  reason: string;
  status: "Pending" | "Approved" | "Rejected";
  currentFillingReserve: number;
  currentTotalQuantity: number;
  requestedByUserId: string;
  requestedByUserName: string;
  requestedAt: string;
  decisionByUserId?: string | null;
  decisionByUserName?: string | null;
  decisionAt?: string | null;
  decisionComment?: string | null;
  priorFillingReserve?: number | null;
  priorTotalQuantity?: number | null;
  newFillingReserve?: number | null;
  newTotalQuantity?: number | null;
  createdAt: string;
}

export interface CreateReserveReleaseRequest {
  quantity: number;
  reason: string;
}

export const reserveReleaseApi = {
  request: async (
    entryId: string,
    body: CreateReserveReleaseRequest
  ): Promise<GreenhouseStockReserveReleaseDto> => {
    const { data } = await apiClient.post<ApiResponse<GreenhouseStockReserveReleaseDto>>(
      `/greenhouse-stock/entries/${entryId}/reserve-releases`,
      { greenhouseStockEntryId: entryId, ...body }
    );
    return data.data;
  },

  pending: async (): Promise<GreenhouseStockReserveReleaseDto[]> => {
    const { data } = await apiClient.get<ApiResponse<GreenhouseStockReserveReleaseDto[]>>(
      "/greenhouse-stock/reserve-releases/pending"
    );
    return data.data ?? [];
  },

  history: async (entryId: string): Promise<GreenhouseStockReserveReleaseDto[]> => {
    const { data } = await apiClient.get<ApiResponse<GreenhouseStockReserveReleaseDto[]>>(
      `/greenhouse-stock/entries/${entryId}/reserve-releases`
    );
    return data.data ?? [];
  },

  approve: async (
    id: string,
    body: { decisionComment?: string }
  ): Promise<GreenhouseStockReserveReleaseDto> => {
    const { data } = await apiClient.post<ApiResponse<GreenhouseStockReserveReleaseDto>>(
      `/greenhouse-stock/reserve-releases/${id}/approve`,
      body
    );
    return data.data;
  },

  reject: async (
    id: string,
    body: { decisionComment: string }
  ): Promise<GreenhouseStockReserveReleaseDto> => {
    const { data } = await apiClient.post<ApiResponse<GreenhouseStockReserveReleaseDto>>(
      `/greenhouse-stock/reserve-releases/${id}/reject`,
      body
    );
    return data.data;
  },
};
